import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("sw-lang") : null;
    return saved || "ar";
  });

  const t = useMemo(() => translations[lang] || translations.ar, [lang]);
  const dir = t.dir;

  useEffect(() => {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    document.body.classList.remove("lang-ar", "lang-en", "lang-ur");
    document.body.classList.add(`lang-${lang}`);
    window.localStorage.setItem("sw-lang", lang);
  }, [lang, dir]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
